
import { render } from '@wordpress/element';
import BlockPlayer from './player';
window.addEventListener('DOMContentLoaded', (event) => {
    const wrappers = document.getElementsByClassName(`blockplayer-main-area`);
    for(let wrapper of wrappers) {
        const attributesGet = wrapper.getAttribute('data-play');
        const attributes = JSON.parse(attributesGet)
        render(
            <BlockPlayer
                attributes={attributes}
            />,
            wrapper
        );
    }
});
